import z from "zod";
import { LOGIN_ERROR_MESSAGE, LOGIN_EMAIL_FORMAT_MESSAGE } from "../constant";

import { affiliationInfoSchema, businessIdSchema } from "@/api/affiliationType";

export interface LoginResponseData {
  access_token: string;
  refresh_token: string;
  token_type: string;
  // 임시 비밀번호로 로그인한 상태. true 면 강제 변경 모달을 띄운다(로그인 시점에만 판단)
  is_temporary_password: boolean;
}

export interface LoginResponse {
  success: boolean;
  message: string;
  data: LoginResponseData;
}

// 서버는 공백 포함 / 50자 초과를 인증 시도 전에 422 로 끊는다. 같은 제약을 클라이언트에서 먼저 검증한다.
// (이메일 형식 자체는 서버가 검증하지 않으므로 여기서도 강제하지 않는다)
export const loginParamsSchema = z.object({
  email: z
    .string()
    .min(1, LOGIN_ERROR_MESSAGE)
    .max(50, LOGIN_EMAIL_FORMAT_MESSAGE)
    .refine((v) => !/\s/.test(v), LOGIN_EMAIL_FORMAT_MESSAGE),
  password: z.string().min(1, LOGIN_ERROR_MESSAGE),
});
export type LoginParams = z.infer<typeof loginParamsSchema>;

// 계정 직책: 읽기+쓰기 / 읽기전용
export const accountRoleSchema = z.enum(["ADMIN", "MEMBER"]);
export type AccountRole = z.infer<typeof accountRoleSchema>;

export const userInfoSchema = z.object({
  id: z.union([z.string(), z.number()]),
  uuid: z.string(),
  // 계정 이메일 (login_id 대체)
  email: z.string(),
  name: z.string(),
  phone: z.string().nullish(),
  affiliation: affiliationInfoSchema,
  // 호출자 자신의 사업자 id. 소속(운영사·고객사) id 와 값 공간이 다르다.
  // MASTER 는 가리킬 사업자가 없다
  company_id: businessIdSchema.nullish(),
  role: accountRoleSchema,
  approval_status: z.string(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
});

export type UserInfo = z.infer<typeof userInfoSchema>;
